import React, { Component } from 'react';

import { roundNumber } from "../Helpers";

import './CombinationPrice.css';
import currencySymbol from '../utils/currencySymbol';
import shouldShowPrice from '../utils/shouldShowPrice';
import CountryStore from '../flux/CountryStore';

/**
 * Renders a simple element showing a static price for the type of
 * configuration in the product configuration panel.
 */
class CombinationPrice extends Component {
  render() {
    return (
      <div className="combinationPrice">
        <div className="combinationPrice__text">{this.props.text}</div>
        <div className="combinationPrice__price">{shouldShowPrice(CountryStore.getState()) ? `+ ${roundNumber(this.props.price)} ${currencySymbol()}` : ''}</div>
      </div>
    );
  }
}

CombinationPrice.defaultProps = {
  text: ' ',
  price: 0.00,
};

export default CombinationPrice;



// WEBPACK FOOTER //
// ./src/components/CombinationPrice.js